import { render, staticRenderFns } from "./ConsultasPorPaciente.vue?vue&type=template&id=db472a7e"
import script from "./ConsultasPorPaciente.vue?vue&type=script&lang=js"
export * from "./ConsultasPorPaciente.vue?vue&type=script&lang=js"
import style0 from "./ConsultasPorPaciente.vue?vue&type=style&index=0&id=db472a7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports